import { TOPANDBOTTOMCUSTOMER } from "../../constants/action-types";
const initialState = {
    CustomersAttributeList: [],
    activeStatusCustomerAttr: [],
    CustomersAttribute: [],
    SortedCustomersAttribute: []
}

const TopAndBottomCustomerReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOPANDBOTTOMCUSTOMER.SORT_CUSTOMERS_ATRTRIBUTE: {
            return Object.assign({}, state, {
                SortedCustomersAttribute: action.payload
            });

        }
        case TOPANDBOTTOMCUSTOMER.GET_CUSTOMERS_ATRTRIBUTE_LIST: {
            return Object.assign({}, state, {
                CustomersAttributeList: action.payload
            });

        }
        case TOPANDBOTTOMCUSTOMER.ACTIVE_STATUS_CUSTOMER_ATTRIBUTE: {
            return Object.assign({}, state, {
                activeStatusCustomerAttr: action.payload
            });

        }
        case TOPANDBOTTOMCUSTOMER.GET_CUSTOMERS_ATRTRIBUTE: {
            return Object.assign({}, state, {
                CustomersAttribute: action.payload
            });

        }
        case TOPANDBOTTOMCUSTOMER.UPDATE_CUSTOMERS_ATRTRIBUTE_LIST: {
            return Object.assign({}, state, {
                CustomersAttributeList: action.payload
            });

        }
        default:
            return state
    }

}

export default TopAndBottomCustomerReducer